export const SystemRoleName = {
	Admin: 'Administrator',
	Editor: 'Redaktor'
};
